import { NewsDto } from "by/gamefactory/cityversetycoon/networking/data/responses/news/NewsDto";
import { NewsCard } from "./NewsCard";

export class StealNewsCard extends NewsCard {
    public readonly stealAmountInCoins: number;

    public constructor(newsDto: NewsDto, afterClaim?: boolean) {
        super(newsDto, afterClaim);
        this.stealAmountInCoins = newsDto.stealAmountInCoins ?? 0;
    }
}
